import React from 'react';
import { observer } from 'mobx-react';
import { CardNoteWrapper } from '@seedlang/hoc';
import styled from '@emotion/styled';
import { Constants } from '@seedlang/constants';
import Text from 'components/text';
import { isBlank, isPresent } from '@seedlang/utils';
import CommentCreate from 'components/comment/comment_create';
import InPlaceCheckbox from 'components/form/in_place_checkbox';
import TextDisplay from 'components/text_display';
import DeleteButton from 'components/button/delete_button';
import CommentButton from 'components/button/comment_button';
import { CloseIcon, PencilIcon } from '@seedlang/icons';
import SentenceSubmissionIndex from 'components/sentence_submission/sentence_submission_index';

const Wrapper = styled.div`
  padding: 0 20px 20px;
  .pencil-icon {
    width: 10px;
    margin-right: 5px;
  }
`;

const CreateNoteWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .close-icon {
    position: absolute;
    top: 10px;
    right: 5px;
    cursor: pointer;
    svg {
      fill: #737373;
      width: 20px;
    }
  }
`;

const MarkdownWrapper = styled.div`
  padding: 20px 20px 10px 20px;
  border-radius: 5px;
  background: rgb(241, 241, 241);
`;

const BottomBar = styled.div`
  display: flex;
  margin: 10px 0 0 0;
  position: relative;
`;

const Links = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  flex-wrap: wrap;
  .fa-times {
    margin-right: 5px;
  }
`;

const CheckboxWrapper = styled.div`
  margin-top: 10px;
`;

@observer
class CardNote extends React.Component {

  render() {
    return (
      <Wrapper>
        {
          this.props.overlayId &&
          <Text
            heading='3'
            textAlign='center'
            padding='20px 0'
          >
            Review Note
          </Text>
        }
        {
          !this.props.showEdit && isPresent(this.props.card.note) &&
            <MarkdownWrapper>
              <TextDisplay
                markdown={this.props.card.note}
              />
              <BottomBar>
                <Links>
                  <CommentButton
                    onClick={() => this.props.onSetShowEdit(true)}
                  >
                    <PencilIcon />
                    Edit
                  </CommentButton>
                  <DeleteButton
                    allowDeletion
                    onConfirm={() => this.props.onSubmitNote(null)}
                    message='Delete this note?'
                    confirmationMessageFloatsRight
                    right='auto'
                    left='10px'
                    top='-54px'
                  >
                    <CommentButton>
                      <i className='fa fa-times' />
                      Delete
                    </CommentButton>
                  </DeleteButton>
                </Links>
              </BottomBar>
            </MarkdownWrapper>
        }
        {
          (isBlank(this.props.card.note) || this.props.showEdit) &&
            <CreateNoteWrapper>
              {
                isPresent(this.props.card.note) &&
                  <CloseIcon
                    onClick={() => this.props.onSetShowEdit(false)}
                  />
              }
              <CommentCreate
                width='100%'
                height='200px'
                blockTextExpansion
                text={this.props.card.note}
                placeholder='Leave a Private Note'
                onSubmitComment={this.props.onSubmitNote}
                languageId={this.props.card.languageId}
                maxLength={Constants.REVIEW_CARD_MAX_NOTE_LENGTH}
              />
            </CreateNoteWrapper>
        }
        <CheckboxWrapper>
          <InPlaceCheckbox
            allowUpdate
            onChange={this.props.onChangeShowNoteBeforeReveal}
            value={this.props.card.showNoteBeforeReveal}
          >
            Show Note Icon Before Card is Revealed
          </InPlaceCheckbox>
        </CheckboxWrapper>
        {
          this.props.wordId &&
            <SentenceSubmissionIndex
              showTopBorder
              wordId={this.props.wordId}
            />
        }
      </Wrapper>
    );
  }
}

export default CardNoteWrapper(CardNote);
